import type { ReactNode } from 'react';
import { Navigate } from 'react-router';
import { useIsAdmin } from '@/hooks/useIsAdmin';

export interface RequireAdminRouteProps {
  /** Where to redirect a non-admin (a safe, staff-accessible surface). */
  fallback: string;
  children: ReactNode;
}

/**
 * RequireAdminRoute renders its children for admins and redirects everyone else
 * to `fallback`. It guards the analytics/finance routes (Inspection & Analytics,
 * the Dashboard Analytics tab, the Billing Reconciliation tab) so a non-admin
 * can neither reach the data nor land on a broken tab (issue #906). The server
 * (RequireAdmin) is the real security boundary; this is UX/defense-in-depth.
 */
export function RequireAdminRoute({ fallback, children }: RequireAdminRouteProps) {
  const isAdmin = useIsAdmin();
  if (!isAdmin) {
    return <Navigate to={fallback} replace />;
  }
  return <>{children}</>;
}
